import { t } from '@lingui/macro';
import { TExternalFilter, TColumnConfiguration } from 'types';
import {
  ALL_STATUS_VALUES,
  APPLICATION_TABLE_KEYS,
  EXPIRING_STATUS_VALUES,
  OFFERED_STATUS_VALUES,
  PENDING_STATUS_VALUES,
} from 'utils/applications/applications.config';
import { arraysHaveSameItems } from 'utils/common/common';

export const getExternalStatusFilterValue = (
  data: string[],
): TExternalFilter | null => {
  if (arraysHaveSameItems(data, ALL_STATUS_VALUES)) {
    return 'all';
  }
  if (arraysHaveSameItems(data, EXPIRING_STATUS_VALUES)) {
    return 'expiring';
  }
  if (arraysHaveSameItems(data, PENDING_STATUS_VALUES)) {
    return 'pending';
  }
  if (arraysHaveSameItems(data, OFFERED_STATUS_VALUES)) {
    return 'review';
  }
  return null;
};

// Using function because of lingui
export const DEFAULT_COLUMN_CONFIG = (
  showReferredByColumn = false,
): TColumnConfiguration[] => {
  const columns: TColumnConfiguration[] = [
    {
      key: APPLICATION_TABLE_KEYS.term_length,
      label: t`Term length`,
      position: 0,
      display: true,
    },
    {
      key: APPLICATION_TABLE_KEYS.approval_amount,
      label: t`Approval amount`,
      position: 1,
      display: true,
    },
    {
      key: APPLICATION_TABLE_KEYS.requested_amount,
      label: t`Requested amount`,
      position: 2,
      display: true,
    },
    {
      key: APPLICATION_TABLE_KEYS.expiry,
      label: t`Expiry date`,
      position: 3,
      display: true,
    },
    {
      key: APPLICATION_TABLE_KEYS.product_type,
      label: t`Product`,
      position: 4,
      display: false,
    },
  ];

  if (showReferredByColumn) {
    columns.push({
      key: APPLICATION_TABLE_KEYS.referred_by,
      label: t`Referred by`,
      position: 5,
      display: true,
    });
  }
  return columns;
};

export const getColumnReorderPayload = (
  columnConfig: TColumnConfiguration[],
) => {
  let columnOrder = {};
  columnConfig
    .filter((item) => item.display)
    .map((item) => item.label)
    .forEach((item, index) => {
      columnOrder = { ...columnOrder, [`Column ${index + 1}`]: item };
    });
  return columnOrder;
};
